import * as ProgressPrimitive from '@radix-ui/react-progress';
import { ReactNode } from 'react';

import { ColorOrCustom, cn, resolveColorClass } from 'styles';

export interface LinerProgressProps {
  value: number;
  className?: string;
  rounded?: boolean;
  color?: ColorOrCustom;
  trackClassName?: string;
  children?: ReactNode;
}

export function LinearProgress({
  className,
  value,
  rounded,
  color,
  trackClassName,
  children,
  ...props
}: LinerProgressProps) {
  return (
    <ProgressPrimitive.Root
      className={cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        className={cn(
          'relative h-full w-full flex-1 transition-all',
          resolveColorClass(color ?? 'primary', 'bg'),
          rounded && 'rounded-full',
          trackClassName,
        )}
      >
        {children}
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  );
}
